import React, { useEffect, useState } from "react";
import { enablePush, disablePush, pushSupported, pushEnabledLocally } from "../../utils/push";

// A small opt-in control in the manage bar: turns on push notifications for THIS
// device (per-device by design — a family member may want alerts on their phone
// but not their work laptop). Hidden where push isn't supported.
export default function PushToggle({ uid, tenantId }) {
  const [supported, setSupported] = useState(false);
  const [on, setOn] = useState(() => pushEnabledLocally());
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => { pushSupported().then(setSupported); }, []);
  if (!supported) return null;

  const toggle = async () => {
    setBusy(true); setErr(null);
    try {
      if (on) { await disablePush(); setOn(false); }
      else { await enablePush({ uid, tenantId }); setOn(true); }
    } catch (e) {
      setErr(e && e.message ? e.message : "Couldn't update notifications.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="manage-group">
      <label>Notifications</label>
      <button onClick={toggle} disabled={busy} title="Get notified on this device when your Care Circle posts">
        {busy ? "Please wait…" : on ? "🔔 On" : "🔕 Enable"}
      </button>
      {err && <div style={{ color: "#ffb3b3", fontSize: "0.85em", marginTop: "0.25em", maxWidth: "16em" }}>{err}</div>}
    </div>
  );
}
